import { z } from "zod";

export const registerFormSchema = z
  .object({
    name: z.string().min(2, "Lütfen geçerli bir isim giriniz."),
    surname: z.string().min(2, "Lütfen geçerli bir soyad giriniz."),
    email: z.string().email("Lütfen geçerli bir email adresi giriniz."),
    identificationNumber: z
      .string()
      .length(11, "Lütfen geçerli bir kimlik numarası giriniz."),
    parentName: z.string().min(2, "Lütfen geçerli bir isim giriniz."),
    parentSurname: z.string().min(2, "Lütfen geçerli bir soyad giriniz."),
    parentIdentificationNumber: z
      .string()
      .length(11, "Lütfen geçerli bir kimlik numarası giriniz."),
    fullAddress: z.string().min(10, "Lütfen geçerli bir adres giriniz."),
    password: z.string().min(6, "Lütfen en az 6 karakterli bir şifre giriniz."),
    confirmPassword: z
      .string()
      .min(6, "Lütfen en az 6 karakterli bir şifre giriniz."),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "Şifreler uyuşmuyor.",
    path: ["confirmPassword"],
  });

export type RegisterFormData = z.infer<typeof registerFormSchema>;
